import React, {PropTypes} from 'react';
import utils from '../../utils/utils';
import {Link} from 'react-router';
const s = require('./post.scss');

const striptags = require('striptags');

const Post = ({loading, article}) => {
  if (loading) {
    return <span data-hook="post-loading-content"/>;
  }

  return (
    <div data-hook="post-content-wrapper" data-hide={loading} className={s.postsWrapper}>
      {utils.getHelemt({title: article.title, description: `${striptags(article.content).substring(0, 150)}`})}
      <div className={s.content}>
        <label data-hook="post-date" className={s.date}>{`${article.date.month} ${article.date.day}, ${article.date.year}`}</label>
        <h1 data-hook="post-title" className={s.pageTitle}>{article.title}</h1>
        <div data-hook="post-content" className={s.pageDescription}>{utils.getContent(article.content)}</div>
      </div>
      <hr className={s.seperator}/>
      <Link to="/"><div className={s.moreButton}>See all Updates</div></Link>
    </div>
  );
};

Post.propTypes = {
  loading: PropTypes.bool.isRequired,
  article: PropTypes.object.isRequired
};

export default Post;



// WEBPACK FOOTER //
// ./components/Post/Post.js